import * as React from 'react';
import PropTypes from 'prop-types'


export default class Image extends React.Component<any, any>{
    static PropTypes = {
        url: PropTypes.string.required,
        alt: PropTypes.string
    }

    render(){
        const {url, alt} = this.props;

        return (
            <div className="col-12 mt-4">
                <img src={url} width="100%" height="100%" alt={alt} />
            </div>
        )
    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/image.tsx